/* 后台管理系统 核心类  */
import Vue from 'vue'

// 全局注册组件
import AppPageHeader from "@/core/components/AppPageHeader.vue";
Vue.component('AppPageHeader', AppPageHeader)

import AppNav from "@/core/components/AppNav.vue";
Vue.component('AppNav', AppNav)

import AppHeader from "@/core/header/AppHeader.vue";
Vue.component('AppHeader', AppHeader)

import AppAside from "@/core/menu/AppAside.vue";
Vue.component('AppAside', AppAside)

import RequireStar from "@/views/components/role/RequireStar.vue";
Vue.component('RequireStar',RequireStar)

